import { encryptAES } from "../../services/CryptoService";

const isEncryptionEnabled = false;

export const transformRequest = (data) => {
    if (data && typeof data === "object") {
        data = handleDates(data); 
    }

    if (isEncryptionEnabled) {
        return encryptAES(data);
    }
    return data;
}

export const encryptQueryString = (url) => {
    if (isEncryptionEnabled) {
        const urlParts = url.split("?");
        if (urlParts.length === 2) {
            const queryString = urlParts[1];
            const encryptedQueryString = encryptAES(queryString); // Replace with your encryption logic
            return `${urlParts[0]}?${encryptedQueryString}`;
        }
    }
    return url;
}


const handleDates = (obj) => {
    if (obj instanceof Date) {
        return obj.getFullYear() + "-" +
               String(obj.getMonth() + 1).padStart(2, "0") + "-" +
               String(obj.getDate()).padStart(2, "0");
    }

    if (Array.isArray(obj)) {
        return obj.map(handleDates);
    }

    if (obj && typeof obj === "object") {
        const newObj = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                newObj[key] = handleDates(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
};